import { autoinject } from "aurelia-framework";
import type { IRequestHandler } from "./i-handlers";
import config from "../config";

@autoinject()
export class DeviceTypeHandler implements IRequestHandler {
    public async handle(request: Request): Promise<void> {
        if (request.url.indexOf(config.messagingServiceServerURL) == -1) return;
        if (!request.headers.get("DeviceType")) {
            request.headers.append("DeviceType", "1"); // 1 is the enum for Web in BE
        }
    }
}
